export default "__VITE_ASSET__9d82fbd3__"